import { ServerApi } from 'modules/api/server-api';

export const fetchCompanyOffices = (api: ServerApi) => async () => {
  const response = await api.get('/company/offices');
  return response.data.offices;
};
